import { Workflow, Download, Trash2, Folder, Settings } from 'lucide-react';
import BotChip from '../../../../../components/BotChip/BotChip';

export default function FlowCard({ flow, folder, botLabel, botPhotoUrl, onToggle, onMove, onExport, onDelete, onEdit }) {
  const starts = flow.count_starts ?? 0;
  const finished = flow.count_finished ?? 0;
  const pct = starts > 0 ? ((finished / starts) * 100).toFixed(1) : '0.0';

  return (
    <div className="sx-gcard">
      {/* flexGrow: 1 mantém stats/rodapé alinhados quando o grid iguala as alturas */}
      <div style={{ padding: '16px 18px 14px', flexGrow: 1 }}>
        <div className="flex items-center justify-between gap-3 mb-4">
          <div className="flex items-center gap-2 min-w-0">
            <div className="flow-card-icon mr-2">
              <Workflow size={16} />
            </div>
          </div>

          {/* Ações — aparecem no hover (toggle incluso) */}
          <div className="flow-card-actions">
            <label className="toggle-wrapper flex-shrink-0" title={flow.is_active ? 'Ativo' : 'Inativo'}>
              <input type="checkbox" checked={flow.is_active} onChange={() => onToggle(flow)} />
              <span className="toggle-slider" />
            </label>
            <button className="action-btn" title={folder ? `Pasta: ${folder.name}` : 'Mover para pasta'} onClick={() => onMove(flow)}>
              <Folder size={14} />
            </button>
            <button className="action-btn action-btn--blue" title="Exportar" onClick={() => onExport(flow)}>
              <Download size={14} />
            </button>
            <button className="action-btn action-btn--red" title="Excluir" onClick={() => onDelete(flow)}>
              <Trash2 size={14} />
            </button>
          </div>
        </div>

        {/* Título — truncate direto no elemento do texto para o ellipsis funcionar */}
        <div className="text-md font-bold truncate mb-2" title={flow.name}>
          {flow.name}
        </div>

        {/* Tag da pasta — linha sempre presente para os cards terem a mesma estrutura */}
        <div className="flex items-center gap-2" style={{ minHeight: 24 }}>
          <BotChip photoUrl={botPhotoUrl} label={botLabel} />

          {flow.is_active && (
            <span className="sx-pill sx-pill--green"><span className="sx-pill-dot"></span>Ativo</span>
          )}

          {folder && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                maxWidth: '100%',
                padding: '2px 10px',
                borderRadius: 7,
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: '0.04em',
                color: folder.color,
                background: `${folder.color}1f`,
                border: `1px solid ${folder.color}40`,
              }}
            >
              <span className="truncate">{folder.name}</span>
            </span>
          )}
        </div>
      </div>

      {/* Stats com divisória */}
      <div className="flow-stats-split" style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.07)', margin: 0 }}>
        <div>
          <div className="flow-stat-label">Starts</div>
          <div className="flow-stat-num text-emerald-400">{starts}</div>
        </div>
        <div>
          <div className="flow-stat-label">Conversão</div>
          <div className="flow-stat-num text-white">{pct}%</div>
        </div>
      </div>

      {/* Ação principal — linha inteira no rodapé do card */}
      <button
        className="w-full hover:bg-white/[0.04] transition-colors text-sm font-bold text-white"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          padding: '0.8rem',
          background: 'transparent',
          border: 'none',
          borderTop: '1px solid rgba(255,255,255,0.07)',
          borderRadius: '0 0 14px 14px',
          cursor: 'pointer',
        }}
        onClick={() => onEdit(flow)}
      >
        <Settings size={14} strokeWidth={2.5} /> Editar Fluxo
      </button>
    </div>
  );
}
